import React from 'react';
import axios from 'axios';
import { createContext } from 'use-context-selector';

import config from '@config';

import { IUsersContext, UserInfo } from './types';
import { hasSalesGroup } from './sales-groups';

export const UsersContext = createContext({} as IUsersContext);

export const UsersProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [sellersUsers, setSellersUsers] = React.useState<Array<UserInfo>>([]);
  const [isLoading, setLoading] = React.useState<boolean>(false);

  const getSellersUsersHandler = React.useCallback(function (name?: string) {
    setLoading(true);
    axios
      .get(`${config.SERVER_BASE_URL}/api/users/sellers`, {
        withCredentials: true,
        params: name ? { name } : undefined,
      })
      .then((response) => {
        const parsedUsersList: UserInfo[] = response.data.map(
          (user: any) =>
            ({
              id: user.app_metadata.uuid as string,
              authId: user.user_id,
              email: user.email,
              isAdmin: hasSalesGroup(user.app_metadata.authorization.groups, 'admin'),
              name: user.name,
              phone: user.phone_number,
              pictureUrl: user.picture,
              groups: user.app_metadata.authorization.groups,
            } as UserInfo),
        );

        setSellersUsers(parsedUsersList);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <UsersContext.Provider
      value={{
        sellersUsers,
        getSellersUsersHandler,
        isLoading,
      }}
    >
      {children}
    </UsersContext.Provider>
  );
};
